import React from 'react'

function Upvote({ size, color, fill, strokeWidth }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 25" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M7 11.5938L11 2.59375C11.7956 2.59375 12.5587 2.90982 13.1213 3.47243C13.6839 4.03504 14 4.7981 14 5.59375V9.59375H19.66C19.9499 9.59047 20.2371 9.65025 20.5016 9.76897C20.7661 9.88768 21.0016 10.0625 21.1919 10.2813C21.3821 10.5 21.5225 10.7576 21.6033 11.036C21.6842 11.3144 21.7035 11.6071 21.66 11.8938L20.28 20.8937C20.2077 21.3707 19.9654 21.8054 19.5979 22.1178C19.2304 22.4302 18.7623 22.5992 18.28 22.5938H7M7 11.5938V22.5938M7 11.5938H4C3.46957 11.5937 2.96086 11.8045 2.58579 12.1795C2.21071 12.5546 2 13.0633 2 13.5938V20.5938C2 21.1242 2.21071 21.6329 2.58579 22.008C2.96086 22.383 3.46957 22.5938 4 22.5938H7" stroke={color} stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )
}

export default Upvote